import * as React from 'react';
import FormSection from 'Components/FormSection';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import { useIntl } from 'react-intl';
import colors from '../../../../../config/theme/colors';

const ThymectomyForm = ({ formData, editing }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  React.useEffect(() => {
    if (!formData.document.code) {
      formData.onChange?.({
        code: { codeSystem: 'http://snomed.info/sct', code: '399750009', display: fm('procedure.thymectomy') },
      });
    }
  }, []);

  return (
    <>
      <FormSection>
        <FormRow title="general.date">
          <InputHandler editing={!!editing} name="date" type="PartialDate" formData={formData} dateDefault="now" />
        </FormRow>
        <FormRow title="procedure.finding.pad">
          <InputHandler
            type="Radio"
            editing={true}
            name="finding"
            formData={formData}
            options={['normal']}
            optionFormatter={o => `${o}`}
          />
          <div style={{ color: colors.tertiaryText, marginBottom: '1.25rem', textTransform: 'uppercase' }}>
            {fm('general.or')}
          </div>
          <InputHandler
            type="Checkbox"
            editing={true}
            name="finding"
            formData={formData}
            options={['hyperplasia', 'thymoma']}
            optionFormatter={o => fm(`procedure.finding.${o}`)}
          />
        </FormRow>
        <FormRow title="procedure.additionalInformation">
          <InputHandler
            editing={!!editing}
            name="additionalInformation"
            type="TextArea"
            formData={formData}
            placeholder={'procedure.additionalInformation'}
            width={35}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'procedure'>>;
  editing: string;
}

export default ThymectomyForm;
